<app-ui-reminders-timeline
    [moreActions]="moreActions"
    moreActionsButtonLabel="Settings"
    [months]="months"
    [showAddReminder]="permissionService.isAvailable('customers.maintain-reminders.add-reminder')"
    [showChangeStatus]="permissionService.isAvailable('customers.maintain-reminders.change-reminder-status')"
    [showViewReminder]="permissionService.isAvailable('customers.maintain-reminders.view-reminder')"
    [showDeleteReminder]="permissionService.isAvailable('customers.maintain-reminders.delete-reminder')"
    (onMoreAction)="resolveSettingsAction($event)"
    (onCreateClick)="addReminder()"
    (onChangeStatus)="saveReminder($event)"
    (onViewReminder)="viewReminder($event)"
    (onDeleteReminder)="deleteReminder($event)"></app-ui-reminders-timeline>
